// const LineShape = (canvas, fabric) => {
//     let pointer
//     let isDrawingLine = false
//     let pointerPoints
//     let polygon

//     canvas.on('mouse:down', (o) => {
//         if (!canvas.isDrawingStraightLineMode) return

//         if (canvas?.getActiveObject()) return
//         console.log('Drawing line shape')

//         isDrawingLine = true
//         pointer = []
//         pointerPoints = canvas.getPointer(o.e)
//         pointer[0] = { x: pointerPoints.x, y: pointerPoints.y }

//         polygon = new fabric.Polyline(pointer, {
//             strokeWidth: 2,
//             stroke: window.globalColor,
//             fill: false,
//             scaleX: 1,
//             scaleY: 1,
//             edit: false,
//             hasBorders: false,
//             objectCaching: false,
//             transparentCorners: false,
//             hasControls: false
//         })
//         canvas.add(polygon)
//     })

//     canvas.on('mouse:move', (o) => {
//         if (!isDrawingLine) return
//         pointerPoints = canvas.getPointer(o.e)
//         const dims = polygon._calcDimensions()
//         pointer[1] = { x: pointerPoints.x, y: pointerPoints.y }

//         polygon.set({
//             width: dims.width,
//             height: dims.height,
//             left: dims.left,
//             top: dims.top,
//             pathOffset: {
//                 x: dims.width / 2 + dims.left,
//                 y: dims.height / 2 + dims.top
//             },
//             dirty: true
//         })
//         canvas.requestRenderAll()
//         canvas.calcOffset()
//     })

//     canvas.on('mouse:up', () => {
//         if (!isDrawingLine) return
//         polygon.setCoords()
//         isDrawingLine = false

//         const midPoint = polygon.getCenterPoint();
//         const middleControl = new fabric.Circle({
//             left: midPoint.x,
//             top: midPoint.y,
//             radius: 5,
//             fill: 'red',
//             originX: 'center',
//             originY: 'center',
//             hasBorders: false,
//             hasControls: false,
//             selectable: false,
//             visible: false
//         });

//         middleControl.on('moving', function () {
//             // Logic to update the polyline based on the control's position
//             // This might involve recalculating the polyline points
//         });

//         canvas.add(middleControl);
//         canvas.bringToFront(middleControl);

//         canvas.fire('object:modified')
//     })
// }

// export default LineShape

const LineShape = (canvas, fabric) => {
    let isDrawingLine = false
    let startPoint, endPoint
    let polyline, middleControl

    canvas.on('mouse:down', (o) => {
        if (!canvas.isDrawingStraightLineMode) return

        if (canvas?.getActiveObject()) return
        isDrawingLine = true
        startPoint = canvas.getPointer(o.e)
        //  console.log('startPoint:', startPoint)

        polyline = new fabric.Polyline([startPoint, startPoint, startPoint], {
            strokeWidth: 2,
            stroke: window.globalColor,
            fill: false,
            hasBorders: true,
            hasControls: true,
            objectCaching: false,
            transparentCorners: false,
            selectable: true,
            evented: true
            // strokeUniform: true
        })
        // console.log('polyline-down:', polyline)
        canvas.add(polyline)
        //  canvas.requestRenderAll();
    })

    canvas.on('mouse:move', (o) => {
        if (!isDrawingLine) return
        endPoint = canvas.getPointer(o.e)
        const dims = polyline._calcDimensions()
        // Update the last point of the polyline to create the line
        polyline.points[1] = endPoint

        polyline.set({
            width: dims.width,
            height: dims.height,
            left: dims.left,
            top: dims.top,
            pathOffset: {
                x: dims.width / 2 + dims.left,
                y: dims.height / 2 + dims.top
            },
            dirty: true
        })
        // console.log('polyline-mouse-moving:', polyline)

        //   canvas.renderAll();
        canvas.requestRenderAll()
        canvas.calcOffset()
    })

    canvas.on('mouse:up', () => {
        if (!isDrawingLine) return
        polyline.setCoords()
        isDrawingLine = false

        // Add the middle control point
        middleControl = createMiddleControl(startPoint, endPoint)
        //  canvas.add(middleControl);

        // Update the polyline points to include the middle point
        updatePolylinePoints(polyline, startPoint, middleControl, endPoint)
        //  console.log('polyline-up:', polyline)

        polyline.on('object:moving', () => {
            const start = polyline.points[0]
            const end = polyline.points[2]
            updatePolylinePoints(polyline, start, middleControl, end)
        })
        //canvas.renderAll();
        //canvas.requestRenderAll();

        // Event listeners for the middle control point
        middleControl.on('moving', (options) => {
            middleControl.visible = false // Make the control invisible while moving
            const newMidPoint = canvas.getPointer(options.e)
            updatePolylinePoints(polyline, startPoint, newMidPoint, endPoint)
            //  console.log('polyline--middle-moving:', polyline)
            canvas.renderAll()
            canvas.requestRenderAll()
        })

        middleControl.on('moved', (options) => {
            middleControl.visible = true // Make the control visible again once moved

            const newMidPoint = canvas.getPointer(options.e)
            updatePolylinePoints(polyline, startPoint, newMidPoint, endPoint)

            //   console.log('polyline-middle-moved:', polyline)

            canvas.renderAll()
            canvas.requestRenderAll()
        })

        canvas.on('before:selection:cleared', (e) => {
            //  console.log('before:selection:cleared:', e)
            if (e.target === middleControl) {
                canvas.setActiveObject(polyline)
            }
        })

        canvas.setActiveObject(polyline)
        // canvas.renderAll();
        canvas.requestRenderAll()
        canvas.fire('object:modified')
    })
}

function createMiddleControl(startPoint, endPoint) {
    const midPoint = {
        x: (startPoint.x + endPoint.x) / 2,
        y: (startPoint.y + endPoint.y) / 2
    }
    return new fabric.Circle({
        left: midPoint.x,
        top: midPoint.y,
        strokeWidth: 2,
        radius: 5,
        fill: '#ffffff',
        stroke: '#ff0000',
        hasBorders: false,
        hasControls: false,
        selectable: true,
        originX: 'center',
        originY: 'center',
        objectCaching: false
    })
}

function updatePolylinePoints(polyline, start, middle, end) {
    const midPoint = {
        x: (start.x + end.x) / 2,
        y: (start.y + end.y) / 2
    }

    // Update the positions of the polyline points
    polyline.points[0] = start
    polyline.points[1] = midPoint // Set the middle point
    polyline.points[2] = end

    // Update the position of the middle control point
    middle.set({ left: midPoint.x, top: midPoint.y })

    polyline.setCoords()
    middle.setCoords()
    // canvas.requestRenderAll();
}

export default LineShape
